import { Row } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./styles.css";

export function OnBillingCard({ data, status }) {
  const [contractLength, setContractLength] = useState();
  var editResponse = useSelector((state) => state.messagesReducer);
  let userProfile1 = JSON.parse(localStorage.getItem("userProfile"));
  const [extendContract, setExtendContract] = useState(null);
  let BidType = data?.OfferCard?.BidType;

  const contrachLengthOptions = [
    {
      IdealContractLengthId: 1,
      IdealContractLengthName: "1 month",
      IdealContractLengthValue: 1,
    },
    {
      IdealContractLengthId: 2,
      IdealContractLengthName: "2 months",
      IdealContractLengthValue: 2,
    },
    {
      IdealContractLengthId: 3,
      IdealContractLengthName: "3 months",
      IdealContractLengthValue: 3,
    },
    {
      IdealContractLengthId: 4,
      IdealContractLengthName: "4 months",
      IdealContractLengthValue: 4,
    },
    {
      IdealContractLengthId: 5,
      IdealContractLengthName: "5 months",
      IdealContractLengthValue: 5,
    },
    {
      IdealContractLengthId: 6,
      IdealContractLengthName: "6 months",
      IdealContractLengthValue: 6,
    },
    {
      IdealContractLengthId: 7,
      IdealContractLengthName: "7 months",
      IdealContractLengthValue: 7,
    },
    {
      IdealContractLengthId: 8,
      IdealContractLengthName: "8 months",
      IdealContractLengthValue: 8,
    },
    {
      IdealContractLengthId: 9,
      IdealContractLengthName: "9 months",
      IdealContractLengthValue: 9,
    },
    {
      IdealContractLengthId: 10,
      IdealContractLengthName: "10 months",
      IdealContractLengthValue: 10,
    },
    {
      IdealContractLengthId: 11,
      IdealContractLengthName: "11 months",
      IdealContractLengthValue: 11,
    },
    {
      IdealContractLengthId: 12,
      IdealContractLengthName: "1 year",
      IdealContractLengthValue: 12,
    },
    {
      IdealContractLengthId: 13,
      IdealContractLengthName: "1+ years",
      IdealContractLengthValue: 13,
    },
    {
      IdealContractLengthId: 14,
      IdealContractLengthName: "Negotiable",
      IdealContractLengthValue: 14,
    },
    {
      IdealContractLengthId: 15,
      IdealContractLengthName: "13 weeks",
      IdealContractLengthValue: 15,
    },
    {
      IdealContractLengthId: 16,
      IdealContractLengthName: "1 Week",
      IdealContractLengthValue: 16,
    },
    {
      IdealContractLengthId: 17,
      IdealContractLengthName: "6 weeks",
      IdealContractLengthValue: 17,
    },
    {
      IdealContractLengthId: 18,
      IdealContractLengthName: "12 weeks",
      IdealContractLengthValue: 18,
    },
  ];
  const isProposal = BidType === "Proposal" || BidType == "Proposals";
  const card = isProposal ? data?.ProposalCard : data?.BidCard;
  const rate = card?.extendContract?.Rate;
  const budgetType = card?.extendContract?.BudgetType;

  useEffect(() => {
    const contractLength = contrachLengthOptions.filter(
      (res) =>
        res.IdealContractLengthValue ==
        (data?.BidCard
          ? data?.BidCard?.IdealTerm
          : data?.ProposalCard?.IdealTerm)
    );
    setContractLength(contractLength);
    if (
      data?.BidCard?.extendContract?.length ||
      data?.ProposalCard?.extendContract?.length
    ) {
      setExtendContract(
        data?.ProposalCard?.extendContract[
          data?.ProposalCard?.extendContract?.length - 1
        ] ??
          data?.BidCard?.extendContract[
            data?.BidCard?.extendContract?.length - 1
          ]
      );
    }
  }, [data]);

  return (
    <>
      {status == "On Billing" && (
        <>
          <div>
            {/* <strong>Congratulations!</strong> */}
            <p>
              Great news! The candidate is officially hired and moved to “On
              billing”.
            </p>
          </div>
          <div className="onBilling-card-info-div">
            <Row className="info-style">
              <strong>Start date</strong>
              <div>
                {moment(data?.OfferCard?.FromDate).format("DD.MM.yyyy")}
              </div>
            </Row>
            <Row className="info-style">
              <strong>End date</strong>
              <div>{moment(data?.OfferCard?.ToDate).format("DD.MM.yyyy")}</div>
            </Row>

            {userProfile1?.Professions?.ProfessionCode != "IT" ? (
              data?.OfferCard?.BudgetType ? (
                <Row className="info-style">
                  <strong>Pay package</strong>
                  <div>
                    {`
                ${data?.OfferCard?.Currency} 
                ${parseInt(data?.OfferCard?.Rate).toLocaleString("en-US")}
                /
                ${
                  data.OfferCard?.BudgetType === "hr" ||
                  data.OfferCard?.BudgetType === "hour" ||
                  data.OfferCard.BudgetType === "Hourly"
                    ? "HR"
                    : data.OfferCard?.BudgetType === "yr" ||
                      data.OfferCard?.BudgetType === "Year" ||
                      data.OfferCard.BudgetType === "Yearly"
                    ? "YR"
                    : data.OfferCard?.BudgetType === "Week" ||
                      data.OfferCard?.BudgetType === "wk" ||
                      (data.OfferCard.BudgetType === "Weekly" && "WK")
                }`}{" "}
                  </div>
                </Row>
              ) : null
            ) : null}
            <Row className="info-style">
              <strong>Contract duration</strong>
              <div>{data?.OfferCard?.Duration}</div>
            </Row>
          </div>
        </>
      )}
      {status == "Off Billing" && (
        <div>
          <p>
            Great! The gig is complete.
            <br />
            You’ve moved your candidate to “off billing”.
          </p>

          <div className="onBilling-card-info-div">
            <Row className="info-style">
              <strong>Start date</strong>
              <div>
                {Object.keys(card?.extendContract || {}).length > 0
                  ? moment(card?.extendContract?.StartDate).format("DD.MM.yyyy")
                  : moment(data?.OfferCard?.FromDate).format("DD.MM.yyyy")}
              </div>
            </Row>

            <Row className="info-style">
              <strong>End date</strong>
              <div>
                {Object.keys(card?.extendContract || {}).length > 0
                  ? moment(card?.extendContract?.EndDate).format("DD.MM.yyyy")
                  : moment(data?.OfferCard?.ToDate).format("DD.MM.yyyy")}
              </div>
            </Row>

            {userProfile1?.Professions?.ProfessionCode !== "IT" && (
              <Row className="info-style">
                <strong>Pay package</strong>
                <div>
                  {Object.keys(card?.extendContract || {}).length > 0
                    ? `$${rate} / ${budgetType === "Week" ? "WK" : "HR"}`
                    : `${data?.OfferCard?.Currency ?? "USD"} ${
                        extendContract?.Rate ??
                        parseInt(data?.OfferCard?.Rate).toLocaleString("en-US")
                      }/${
                        extendContract?.BudgetType
                          ? extendContract.BudgetType === "Week"
                            ? "Wk"
                            : "Hr"
                          : data.OfferCard?.BudgetType === "hr" ||
                            data.OfferCard?.BudgetType === "hour" ||
                            data.OfferCard?.BudgetType === "Hourly"
                          ? "HR"
                          : data.OfferCard?.BudgetType === "yr" ||
                            data.OfferCard?.BudgetType === "Year" ||
                            data.OfferCard?.BudgetType === "Yearly"
                          ? "YR"
                          : (data.OfferCard?.BudgetType === "Week" ||
                              data.OfferCard?.BudgetType === "wk" ||
                              data.OfferCard?.BudgetType === "Weekly") &&
                            "WK"
                      }`}
                </div>
              </Row>
            )}

            <Row className="info-style">
              <strong>Contract duration</strong>
              <div>
                {Object.keys(card?.extendContract || {}).length > 0
                  ? card?.extendContract?.ContractDuration
                  : data?.OfferCard?.Duration}
              </div>
            </Row>
          </div>
        </div>
      )}

      {status == "Billing Extended" && ( //ed
        <>
          <div>
            <strong>Great!</strong>
            <p>You’ve extended the candidate’s billing.</p>
          </div>
          <div className="onBilling-card-info-div">
            <Row className="info-style">
              <strong>Start Date</strong>
              <div>
                {BidType == "Proposal" || BidType == "Proposals"
                  ? moment(
                      data?.ProposalCard?.extendContract?.StartDate
                    ).format("DD.MM.yyyy")
                  : moment(data?.BidCard?.extendContract?.StartDate).format(
                      "DD.MM.yyyy"
                    )}
              </div>
            </Row>
            <Row className="info-style">
              <strong>End Date</strong>
              <div>
                {BidType == "Proposal" || BidType == "Proposals"
                  ? moment(data?.ProposalCard?.extendContract?.EndDate).format(
                      "DD.MM.yyyy"
                    )
                  : moment(data?.BidCard?.extendContract?.EndDate).format(
                      "DD.MM.yyyy"
                    )}
              </div>
            </Row>
            <Row className="info-style">
              <strong>Pay package</strong>
              {rate ? (
                <div>
                  ${rate} / {budgetType === "Week" ? "WK" : "HR"}
                </div>
              ) : null}
            </Row>
            <Row className="info-style">
              <strong>Contract duration</strong>
              <div>
                {BidType == "Proposal" || BidType == "Proposals"
                  ? data?.ProposalCard?.extendContract?.ContractDuration
                  : data?.BidCard?.extendContract?.ContractDuration}
              </div>
            </Row>
          </div>
        </>
      )}
      {status == "Candidate Cancelled" && (
        <div>
          {/* <strong>Congratulations !</strong> */}
          <p>The candidate is moved to “Cancelled”.</p>
          <div className="onBilling-card-info-div">
            <Row className="info-style">
              <strong>Start date</strong>
              <div>
                {moment(data?.OfferCard?.FromDate).format("MMMM DD, YYYY")}
              </div>
            </Row>
            <Row className="info-style">
              <strong>End Date</strong>
              <div>
                {moment(data?.OfferCard?.ToDate).format("MMMM DD, YYYY")}
              </div>
            </Row>
            {userProfile1?.Professions?.ProfessionCode != "IT" && (
              <Row className="info-style">
                <strong>Estimated pay rate/package</strong>
                <div>
                  {`${data?.OfferCard?.Currency} ${data?.OfferCard?.Rate}/${data?.OfferCard?.BudgetType}`}{" "}
                </div>
              </Row>
            )}
            <Row className="info-style">
              <strong>Contract duration</strong>
              <div>
                {extendContract?.ContractDuration ??
                  data?.OfferCard?.Duration ??
                  "N/A"}
              </div>
            </Row>
          </div>
        </div>
      )}
    </>
  );
}
